import { Typography } from '@mui/material'
import { PieChart } from '@mui/x-charts'
import React from 'react'

export default function CommonChart({ data, width, height, palette }) {
  return (
    <>
      <PieChart
        colors={palette}
        series={[
          {
            data: data
          },
        ]}
        height={height}
        width={width}
      />
    </>
  )
}
